export default __webpack_public_path__ + "static/media/01AW1FEB66.890c663b.jpg";